import { PACKAGING_UNAVAILABLE_EVENT } from '../events';
import { subscribe } from '../../../../base/pubsub';
import { PUB_SUB_EVENTS } from '../../../../base/constants';

/** Variant ids whose journey did not open this page view (no Luxe or Signature passed). */
const unavailable = new Set();
let initialised = false;

/**
 * Hides the "Signature gift box / Add Gift Options" row for every variant known to have no eligible box.
 * @param {ParentNode} [root]
 */
export function hideUnavailableGiftOptions(root = document) {
  root.querySelectorAll('.cart-packaging-row .js-gw-add-luxury-gift-wrap').forEach((button) => {
    if (!(button instanceof HTMLElement) || !unavailable.has(String(button.dataset.variantId))) return;
    const row = button.closest('.cart-packaging-row');
    if (row instanceof HTMLElement) row.hidden = true;
  });
}

/**
 * After the journey declines a piece, hide its "Add Gift Options" (ticket: otherwise the button is not shown),
 * and keep it hidden when the drawer re-renders.
 * @param {Document} [doc]
 */
export function initGiftOptionsAvailability(doc = document) {
  if (initialised) return;
  initialised = true;
  doc.addEventListener(PACKAGING_UNAVAILABLE_EVENT, (event) => {
    const variantId = /** @type {CustomEvent} */ (event).detail?.variantId;
    if (variantId == null || variantId === '') return;
    unavailable.add(String(variantId));
    hideUnavailableGiftOptions(doc);
  });
  doc.addEventListener('CART_DRAWER_UPDATED', () => hideUnavailableGiftOptions(doc));
  // A quantity change re-renders the drawer without CART_DRAWER_UPDATED, then publishes cartUpdate.
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => hideUnavailableGiftOptions(doc));
}

/** Test helper. */
export function resetGiftOptionsAvailability() {
  unavailable.clear();
}
